/* fc-announcement.js (2026-10-12 speed pass): the announcement bar's
   behaviour (header push-down, grid discount sync, click-to-copy, countdown,
   slide rotation), moved out of sections/fc-announcement.liquid so browsers
   cache it across pages. The root is <div id="fc-ann"> and the discount
   config is the JSON script #fc-ann-discount, both static ids (one bar per
   page). The body is the former inline module script, unchanged apart from
   those lookups; it runs once on load and again on shopify:section:load for
   the theme editor, where the disposer registry below tears the previous
   instance down first. */
(function () {
  'use strict';
  function fcAnnInit() {

// ── Dispose previous instance's listeners/observers/intervals ──
// Each editor save reloads the bar section. Without cleanup, every
// reload would stack another MutationObserver on document.body, plus
// event listeners on document/window — causing the theme editor to
// grind to a halt after a few toggles.
//
// NOTE (2026-06-11): these helpers were previously declared INSIDE the
// first IIFE below, but the second IIFE (message rotation) also calls
// __on — which threw "ReferenceError: __on is not defined" in the
// console on every page where rotation ran (flagged by Lighthouse Best
// Practices). They now live at script top level so both IIFEs share
// one definition + one disposer registry.
if (window.__fcAnnDisposers && window.__fcAnnDisposers.length) {
  for (var __fcAnnI = 0; __fcAnnI < window.__fcAnnDisposers.length; __fcAnnI++) {
    try { window.__fcAnnDisposers[__fcAnnI](); } catch(e){}
  }
}
window.__fcAnnDisposers = [];
function __on(target, event, handler, opts){
  target.addEventListener(event, handler, opts);
  window.__fcAnnDisposers.push(function(){
    try { target.removeEventListener(event, handler, opts); } catch(e){}
  });
}
function __observe(observer){
  window.__fcAnnDisposers.push(function(){
    try { observer.disconnect(); } catch(e){}
  });
  return observer;
}
function __interval(id){
  window.__fcAnnDisposers.push(function(){ try { clearInterval(id); } catch(e){} });
  return id;
}

(function(){
  var root = document.getElementById('fc-ann');
  if (!root) return;

  // ── Push transparent (absolute-positioned) header below the bar ──
  // On pages where fc-header runs in transparent overlay mode, its
  // section wrapper is position:absolute; top:0 — which makes the
  // header overlap us. Measure our height and offset the header.
  //
  // This script may run BEFORE fc-header is parsed into the DOM (when
  // the bar is ordered above the header in the header-group). So we
  // retry on every relevant lifecycle event AND poll briefly.
  var rafId = 0;
  function pushHeader(){
    var headerSection = document.querySelector('.shopify-section.fc-header-section');
    if (!headerSection) return false;
    var pos = window.getComputedStyle(headerSection).position;
    if (pos !== 'absolute' && pos !== 'fixed') {
      headerSection.style.top = '';
      return true;
    }
    var h = root.offsetHeight;
    headerSection.style.top = h + 'px';
    return true;
  }
  function schedulePush(){
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(pushHeader);
  }
  // Initial poll: try every animation frame for up to ~1s until
  // fc-header appears in the DOM (handles the bar-above-header case).
  var tries = 0;
  function pollForHeader(){
    if (pushHeader() || tries++ > 60) return;
    requestAnimationFrame(pollForHeader);
  }
  pollForHeader();

  // Re-run on DOM events that may shift either element.
  if (document.readyState === 'loading') {
    __on(document, 'DOMContentLoaded', schedulePush);
  }
  __on(window, 'load', schedulePush);
  __on(window, 'resize', schedulePush);
  if (typeof ResizeObserver !== 'undefined') {
    var __ro1 = __observe(new ResizeObserver(schedulePush));
    __ro1.observe(root);
  }
  // Theme editor: when sections reload/reorder/save, re-apply.
  __on(document, 'shopify:section:load', schedulePush);
  __on(document, 'shopify:section:unload', schedulePush);
  __on(document, 'shopify:section:reorder', schedulePush);

  // ── Apply / remove discount on product grids ──────────────────
  var configEl = document.getElementById('fc-ann-discount');
  if (configEl) {
    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch(e) { cfg = null; }
    if (cfg) {
      var pct = parseFloat(cfg.pct) || 0;
      var scope = cfg.scope || 'specific';
      var collections = cfg.collections || [];
      var discountedHandles = cfg.discountedHandles || {};
      var moneyFormat = cfg.moneyFormat || '${{amount}}';
      var accent = cfg.accentColor || '#ff7a15';
      var enabled = !!cfg.enabled && pct > 0;

      function formatMoney(cents){
        var amount = cents / 100;
        var formatted;
        if (moneyFormat.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
          formatted = Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        } else if (moneyFormat.indexOf('amount_no_decimals_with_space_separator') !== -1) {
          formatted = Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        } else if (moneyFormat.indexOf('amount_no_decimals') !== -1) {
          formatted = Math.round(amount).toString();
        } else if (moneyFormat.indexOf('amount_with_comma_separator') !== -1) {
          formatted = amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        } else if (moneyFormat.indexOf('amount_with_space_separator') !== -1) {
          var parts = amount.toFixed(2).split('.');
          formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1];
        } else if (moneyFormat.indexOf('amount_with_apostrophe_separator') !== -1) {
          formatted = amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        } else {
          formatted = amount.toFixed(2);
        }
        return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/g, formatted);
      }

      function shouldApply(el){
        if (!enabled) return false;
        if (scope === 'all') return true;
        var colsAttr = el.getAttribute('data-fc-product-collections');
        if (colsAttr !== null) {
          var prodCols = colsAttr.split(',').filter(Boolean);
          for (var i = 0; i < collections.length; i++) {
            if (prodCols.indexOf(collections[i]) !== -1) return true;
          }
          return false;
        }
        // Fallback: client-side cards that only know the product handle
        // (e.g. recently-viewed) consult the server-rendered handle map.
        var handle = el.getAttribute('data-fc-product-handle');
        if (handle && discountedHandles[handle]) return true;
        return false;
      }

      function applyOne(el){
        if (el.getAttribute('data-fc-discount-applied') === '1') return;
        var priceCents = parseInt(el.getAttribute('data-fc-product-price'), 10);
        if (!priceCents || isNaN(priceCents)) return;
        if (!shouldApply(el)) return;

        // Cache the original markup so we can restore it on toggle-off.
        if (!el.hasAttribute('data-fc-orig-html')) {
          el.setAttribute('data-fc-orig-html', el.innerHTML);
        }

        var newCents = Math.round(priceCents * (100 - pct) / 100);
        var origStr = formatMoney(priceCents);
        var newStr = formatMoney(newCents);

        if (el.classList.contains('pg-card__price')) {
          el.innerHTML =
            '<span class="pg-price-sale" style="color:' + accent + ';">' + newStr + '</span>' +
            '<span class="pg-price-compare">' + origStr + '</span>';
        } else if (el.classList.contains('fc-rel-card__price-row')) {
          // "You may also like" card
          var fromPrefixRel = el.getAttribute('data-fc-price-varies') === 'true' ? 'From ' : '';
          el.innerHTML =
            '<span class="fc-rel-card__price fc-rel-card__price--sale" style="color:' + accent + ';">' + fromPrefixRel + newStr + '</span>' +
            '<span class="fc-rel-card__compare">' + origStr + '</span>';
        } else if (el.classList.contains('fc-rec-card__price')) {
          // Recently-viewed card
          el.innerHTML =
            '<span class="fc-rec-card__price-now" style="color:' + accent + ';">' + newStr + '</span>' +
            '<span class="fc-rec-card__price-was">' + origStr + '</span>';
        } else if (el.classList.contains('fc-tcard__price') || el.classList.contains('fc-mtcard__price')) {
          // Trending homepage tiles (hero / wide / square / mobile)
          el.innerHTML =
            '<span style="color:' + accent + ';font-weight:inherit;">' + newStr + '</span> ' +
            '<s style="opacity:0.55;font-weight:400;font-size:0.85em;margin-left:6px;">' + origStr + '</s>';
        } else if (el.classList.contains('fc-card__price')) {
          // Homepage Essentials card
          el.innerHTML =
            '<span style="color:' + accent + ';">' + newStr + '</span>' +
            '<span class="fc-card__price-old">' + origStr + '</span>';
        } else if (el.classList.contains('tpg-price')) {
          el.innerHTML =
            '<span style="color:' + accent + ';font-weight:700;">' + newStr + '</span>' +
            '<span class="tpg-price__compare">' + origStr + '</span>';
        } else if (el.classList.contains('fc-pp__price')) {
          // Product info section — keep data-fc-* attributes the section's
          // variant-change handler depends on.
          var saveCents = priceCents - newCents;
          var saveStr = formatMoney(saveCents).replace(/\.00$/, '');
          el.innerHTML =
            '<span class="fc-pp__price-now" data-fc-price style="color:' + accent + ';">' + newStr + '</span>' +
            '<span class="fc-pp__price-was" data-fc-compare>' + origStr + '</span>' +
            '<span class="fc-pp__save" data-fc-save>SAVE ' + saveStr + '</span>';
        } else if (el.classList.contains('price')) {
          var fromPrefix = el.getAttribute('data-fc-price-varies') === 'true' ? 'From ' : '';
          var reg = el.querySelector('.price__regular');
          if (reg) reg.style.display = 'none';
          var sale = el.querySelector('.price__sale');
          if (sale) {
            sale.style.display = '';
            sale.innerHTML =
              '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
              '<span><s class="price-item price-item--regular fc-grid-orig">' + origStr + '</s></span>' +
              '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
              '<span class="price-item price-item--sale price-item--last fc-grid-disc" style="color:' + accent + ';font-weight:700;">' +
                fromPrefix + newStr +
              '</span>';
          }
          el.classList.add('price--on-sale');
        }
        el.classList.add('fc-grid-discounted');
        el.setAttribute('data-fc-discount-applied', '1');
      }

      function removeOne(el){
        if (el.getAttribute('data-fc-discount-applied') !== '1') return;
        var orig = el.getAttribute('data-fc-orig-html');
        if (orig !== null) el.innerHTML = orig;
        el.classList.remove('fc-grid-discounted', 'price--on-sale');
        el.removeAttribute('data-fc-discount-applied');
      }

      function syncAll(){
        var nodes = document.querySelectorAll('[data-fc-product-price]');
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          if (enabled && shouldApply(el)) {
            applyOne(el);
          } else {
            removeOne(el);
          }
        }
      }

      // Expose a callback so other sections (e.g. fc-pp-info on variant
      // change) can request a re-sync after they mutate price markup.
      window.fcAnnSyncDiscount = syncAll;

      // Expose discount state + a price-transform helper so other sections
      // (e.g. bundles) can compute the effective price for a product.
      // `priceDollars` is in dollars; `productCollections` is a string array.
      window.fcAnnGetEffectivePrice = function(priceDollars, productCollections, productHandle){
        if (!enabled) return priceDollars;
        if (scope === 'all') return priceDollars * (100 - pct) / 100;
        productCollections = productCollections || [];
        for (var i = 0; i < collections.length; i++) {
          if (productCollections.indexOf(collections[i]) !== -1) {
            return priceDollars * (100 - pct) / 100;
          }
        }
        if (productHandle && discountedHandles[productHandle]) {
          return priceDollars * (100 - pct) / 100;
        }
        return priceDollars;
      };
      window.fcAnnDiscountState = { enabled: enabled, pct: pct, scope: scope, collections: collections };
      // Dispatch on the document so listeners can react to toggle changes.
      try {
        document.dispatchEvent(new CustomEvent('fc:discount-changed', { detail: window.fcAnnDiscountState }));
      } catch(e){}

      // Initial run + lifecycle hooks.
      syncAll();
      if (document.readyState === 'loading') {
        __on(document, 'DOMContentLoaded', syncAll);
      }
      __on(window, 'load', syncAll);
      __on(document, 'shopify:section:load', syncAll);
      // Catch infinite scroll / quick-add / variant updates that re-render
      // cards. Debounced so a burst of mutations only triggers one syncAll,
      // and only when nodes are actually added (not on every attribute tick).
      try {
        var __syncDebounce;
        var mo = __observe(new MutationObserver(function(muts){
          var added = false;
          for (var i = 0; i < muts.length; i++) {
            if (muts[i].addedNodes && muts[i].addedNodes.length) { added = true; break; }
          }
          if (!added) return;
          clearTimeout(__syncDebounce);
          __syncDebounce = setTimeout(syncAll, 120);
        }));
        mo.observe(document.body, { childList: true, subtree: true });
        window.__fcAnnDisposers.push(function(){ clearTimeout(__syncDebounce); });
      } catch(e){}
    }
  }

  // ── Click-to-copy code ────────────────────────────────────────────
  var copyBtn = root.querySelector('[data-fc-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function(){
      var code = copyBtn.getAttribute('data-fc-copy') || '';
      var done = function(){
        copyBtn.classList.add('is-copied');
        setTimeout(function(){ copyBtn.classList.remove('is-copied'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; document.body.appendChild(ta);
        ta.select(); try { document.execCommand('copy'); } catch(e){}
        document.body.removeChild(ta); done();
      }
    });
  }

  // ── Countdown timer ───────────────────────────────────────────────
  // 2026-07-28: ticks EVERY [data-fc-timer] instance — the timer now
  // renders on both the primary and the offer (secondary) slide.
  var endStr = root.getAttribute('data-end');
  var timerEls = root.querySelectorAll('[data-fc-timer]');
  if (!endStr || !timerEls.length) return;

  var endTs = new Date(endStr).getTime();
  if (isNaN(endTs)) return;

  var onExpire = root.getAttribute('data-on-expire') || 'hide-timer';
  var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
  var tick;

  function render(){
    var diff = endTs - Date.now();
    if (diff <= 0) {
      clearInterval(tick);
      if (onExpire === 'hide-bar') {
        root.style.display = 'none';
      } else {
        for (var i = 0; i < timerEls.length; i++) {
          if (onExpire === 'expired-text') {
            timerEls[i].setAttribute('data-expired', 'true');
          } else {
            timerEls[i].style.display = 'none';
          }
        }
      }
      return;
    }
    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;
    for (var j = 0; j < timerEls.length; j++) {
      var t = timerEls[j];
      var dEl = t.querySelector('[data-d]');
      var hEl = t.querySelector('[data-h]');
      var mEl = t.querySelector('[data-m]');
      var sEl = t.querySelector('[data-s]');
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
  }
  render();
  tick = __interval(setInterval(render, 1000));
})();

// ── Slide rotation ──
// Cycles between primary (.fc-ann__slide[data-fc-slide="primary"]) and the
// optional secondary slide. Pauses on hover so readers can finish; pauses
// when the tab is hidden to save cycles; skipped entirely if the user
// prefers reduced motion (CSS hides the secondary in that case).
// Reuses the section-wide dispose pattern so editor saves don't stack
// multiple intervals on top of each other.
(function(){
  var root = document.getElementById('fc-ann');
  if (!root || root.getAttribute('data-fc-rotate') !== 'true') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var slides = root.querySelectorAll('[data-fc-slide]');
  if (slides.length < 2) return;

  var intervalMs = parseInt(root.getAttribute('data-rotate-ms'), 10) || 4000;
  if (intervalMs < 2500) intervalMs = 2500; // safety floor — anything shorter is unreadable

  var current = 0;
  var paused = false;
  var hidden = false;
  var timerId = null;

  // Inactive slides are aria-hidden AND inert: aria-hidden alone leaves the
  // slide's CTA link keyboard-focusable, which fails the "ARIA hidden element
  // must not contain focusable elements" audit (agentic-browsing scan,
  // 2026-10-01). `inert` drops the subtree from the tab order and the
  // accessibility tree; tabindex="-1" on links/buttons is the fallback for
  // browsers without inert support.
  function setFocusable(slide, on){
    slide.querySelectorAll('a[href], button').forEach(function(el){
      if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
    });
  }
  function show(i){
    slides.forEach(function(s, idx){
      var active = idx === i;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      setFocusable(s, active);
    });
  }
  slides.forEach(function(s, idx){ setFocusable(s, idx === current); });
  // Phones (2026-10-13, owner): a single thin line. Show the slide the section
  // chose (data-fc-mobile-slide) and never start the rotation or the arrows.
  if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
    if (root.getAttribute('data-fc-mobile-slide') === 'secondary') { current = 1; show(1); }
    return;
  }
  function tickRotate(){
    if (paused || hidden) return;
    current = (current + 1) % slides.length;
    show(current);
  }
  function start(){
    if (timerId) return;
    timerId = setInterval(tickRotate, intervalMs);
    window.__fcAnnDisposers.push(function(){ try { clearInterval(timerId); } catch(e){} timerId = null; });
  }
  function stop(){
    if (!timerId) return;
    try { clearInterval(timerId); } catch(e){}
    timerId = null;
  }

  // Pause on hover / focus-within so users get time to read on demand
  __on(root, 'mouseenter', function(){ paused = true; });
  __on(root, 'mouseleave', function(){ paused = false; });
  __on(root, 'focusin',    function(){ paused = true; });
  __on(root, 'focusout',   function(){ paused = false; });

  // Pause when tab is hidden, resume when visible
  __on(document, 'visibilitychange', function(){
    hidden = document.hidden;
    if (hidden) stop(); else start();
  });

  // Manual prev/next arrows: jump, then restart the auto timer so the new
  // slide gets a full interval. Pointer clicks blur the button afterwards so
  // the focus-within pause releases on touch devices (keyboard keeps focus).
  function goTo(i){
    current = (i + slides.length) % slides.length;
    show(current);
    stop();
    start();
  }
  root.querySelectorAll('[data-fc-nav]').forEach(function(btn){
    __on(btn, 'click', function(e){
      goTo(current + (btn.getAttribute('data-fc-nav') === 'prev' ? -1 : 1));
      if (e.detail) { try { btn.blur(); } catch(err){} paused = false; }
    });
  });

  show(0);
  start();
})();
  }
  function run() { if (document.getElementById('fc-ann')) fcAnnInit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-ann')) fcAnnInit();
  });
})();
